import { type FormEvent, useState } from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
import { useAuth } from '../lib/auth';

export default function LoginPage() {
  const { token: savedToken, setToken, setBase, apiBase, verify } = useAuth();
  const navigate = useNavigate();
  const [token, setTokenInput] = useState('');
  const [base, setBaseInput] = useState(apiBase);
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  if (savedToken) {
    return <Navigate to="/" replace />;
  }

  async function onSubmit(e: FormEvent) {
    e.preventDefault();
    setError(null);
    setLoading(true);
    try {
      if (base.trim()) setBase(base.trim());
      setToken(token.trim());
      const ok = await verify();
      if (!ok) {
        setError('鉴权失败：请检查 API Base 与 Bearer Token');
      } else {
        navigate('/', { replace: true });
      }
    } catch (err) {
      setError(err instanceof Error ? err.message : String(err));
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="login-wrap">
      <form className="panel login-card" onSubmit={onSubmit}>
        <h1>CF Mail Inbox</h1>
        <p>使用 Worker 的 Bearer Token 登录。Token 仅保存在本机 localStorage。</p>
        {error && <div className="error-banner">{error}</div>}
        <div className="form-row">
          <label htmlFor="apiBase">API Base URL（可空，开发环境走 Vite 代理）</label>
          <input
            id="apiBase"
            className="input"
            placeholder="https://cf-mail-inbox.xxx.workers.dev"
            value={base}
            onChange={(e) => setBaseInput(e.target.value)}
          />
        </div>
        <div className="form-row">
          <label htmlFor="token">Bearer Token</label>
          <input
            id="token"
            className="input"
            type="password"
            autoComplete="off"
            required
            placeholder="与 wrangler secret API_TOKEN 一致"
            value={token}
            onChange={(e) => setTokenInput(e.target.value)}
          />
        </div>
        <button type="submit" className="btn btn-primary" disabled={loading} style={{ width: '100%' }}>
          {loading ? '验证中…' : '进入收件箱'}
        </button>
      </form>
    </div>
  );
}
